import defaultValues from "@/constant/defaultValues";
import { useState } from "react";
import { default as ReactSelect, components } from "react-select";
import ButtonAdminpanel from "../ButtonAdminpanel";
import DateRangeFilterPicker from "../DateRangeFilterPicker";
import moment from "moment";
import Emitter from "@/utils/Emitter";
import { isEmpty, map } from "lodash";


const OtpFilter = (props) => {

    const {  TRADE_MODE,  admin } = defaultValues;
    const [tradeModeList, setTradeModeList] = useState(TRADE_MODE);
    const [selectedTradeMode, setSelectedTradeMode] = useState(null);
    const [dateRange, setDateRange] = useState(null);

    const today = new Date();

    const CustomOption = ({ innerRef, innerProps, isSelected, label }) => (

        <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center' }} className={isSelected ? "div-item-selected" : "div-item-unselected"} >
            {/* <input type="checkbox" checked={isSelected} readOnly /> */}
            {isSelected && <div className={` item-selected `}><label style={{ marginLeft: '8px' }}>{label}</label></div>}
            {!isSelected && <div className={` item-selected2 `}><label style={{ marginLeft: '8px' }}>{label}</label></div>}

        </div>

    );

    const MoreSelectedBadge = ({ items }) => {
        const style = {
            marginLeft: "auto",
            background: "#d4eefa",
            borderRadius: "4px",
            fontFamily: "Open Sans",
            fontSize: "11px",
            padding: "3px",
            order: 99,
        };

        const title = items.join(", ");
        const length = items.length;
        const label = `+ ${length} item${length !== 1 ? "s" : ""} selected`;

        return (
            <div style={style} title={title}>
                {label}
            </div>
        );
    };

    const MultiValue = ({ index, getValue, ...props }) => {
            const maxToShow = 2;
            const overflow = getValue()
                .slice(maxToShow)
                .map((x) => x.label);
    
            return index < maxToShow ? (
                <components.MultiValue {...props} />
            ) : index === maxToShow ? (
                <MoreSelectedBadge items={overflow} />
            ) : null;
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            '&:hover': {
            },
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#4c9bdb', // Background of the selected multi-value items
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#fff', // Color of the text inside the multi-value
            fontSize: "20px"
        }),

        multiValueRemove: (provided) => ({
            ...provided,
            color: '#df0024', // Remove button color
            ':hover': {
                backgroundColor: '#df0024', // Background color on hover for the remove button
            },
        }),
    };
    
    const handleTradeModeChange = (val) => {
        setSelectedTradeMode(val)
    }

    const filterOtpList = () => {
        console.log("filterOtpList >>>>>>>>>>>>>>> ");
        let filterObj = {
            offset: admin.OFFSET,
            limit: admin.LIMIT,
            current_page: 1
        }

        filterObj.trade_mode = map(selectedTradeMode, 'value');
        let dRange = dateRange;
        if(!isEmpty(dRange)) {
            let sdate = dRange[0];
            sdate = moment(sdate).format('YYYY-MM-DD');

            let edate = dRange[1];
            edate = moment(edate).format('YYYY-MM-DD');

            dRange[0] = sdate;
            dRange[1] = edate;
        }
        filterObj.register_dates = dRange;

        console.log("Filter Obj === ", filterObj);

        Emitter.emit("SET_OTP_FILTER", filterObj);
        setTimeout(() => {
            Emitter.emit("FILTER_OTP_LIST", filterObj);
        },1000);
    }

    const resetOtpList = () => {

        setDateRange(null);
        setSelectedTradeMode(null);

        let filterObj = {
            offset: admin.OFFSET,
            limit: admin.LIMIT,
            current_page: 1
        }
        filterObj.trade_mode = [];
        filterObj.register_dates = [];

        Emitter.emit("SET_OTP_FILTER", filterObj);
        setTimeout(() => {
            Emitter.emit("FILTER_OTP_LIST", filterObj);
        },1000);
    }

    const defaultCalendarValue = [
        new Date(today.getFullYear(), today.getMonth() - 1, 1),
        new Date(today.getFullYear(), today.getMonth(), 1)
    ];

    const handleChange = (val) => {
        setDateRange(val);    
    }


    return (<div className="bg-white shadow rounded p-4 mb-4">
        <div className="row paid-members-filter">
            <div className="col-md-6 col-xxl-3 col-lg-6 my-1">
                <ReactSelect
                    options={tradeModeList}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ Option: CustomOption, IndicatorSeparator: () => null, MultiValue }}
                    onChange={handleTradeModeChange}
                    value={selectedTradeMode}
                    removeSelected={false}
                    styles={customStyles}
                    placeholder="Select Trade Mode"
                    className="member-filter-container"
                    classNamePrefix="member-filter-select"
                    noOptionsMessage={() => "No Trade Mode Found"}
                    id="trade_mode_dropdown"
                />
            </div>
            <div className="col-md-6 col-xxl-3 col-lg-6 my-1 date-range">
                <DateRangeFilterPicker 
                    value={dateRange}
                    onChange={handleChange}
                    defaultCalendarValue={defaultCalendarValue}
                    disabledDate={(current) => {
                      return moment(current).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD'); 
                    }}
                    placeholder={'Select registration date range'}
                />
            </div>
            
            <div className="filter-search-btn col-xl-4 col-md-6 d-flex align-items-center mt-2">
                <div className="d-flex align-items-center">
                    <ButtonAdminpanel
                        type="button"
                        onClick={filterOtpList}
                        className="btn-regi"
                    >
                        {" "}
                        <i className="fa-solid fa-magnifying-glass text-white"></i> Search{" "}
                    </ButtonAdminpanel>
                    <button type="button" className=" btn filter-reset-btn mx-2" onClick={resetOtpList}>
                        <svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g fill="none" fillRule="evenodd" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" transform="matrix(0 1 1 0 2.5 2.5)"> <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8"></path> <path d="m4 1v4h-4" transform="matrix(1 0 0 -1 0 6)"></path> </g> </g></svg>
                        Reset</button>
                </div>
            </div>
        </div>
        </div>)
}

export default OtpFilter;